// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.selected-categories {
    padding: 8px 12px;
    border-bottom: 1px solid rgb(36 42 101 / 45%);
}

.selected-categories h6 {
    margin: 0 0 6px 0;
    font-size: 13px;
    font-weight: 600;
    color: #666;
}

.selected-categories-list {
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    padding: 0;
    margin: 0;
}

.selected-category-button {
    color: rgb(65, 65, 65);
    background-color: #d2d6e0;
    border: none;
    border-radius: 12px;
    padding: 4px 8px;
    font-size: 10px;
    cursor: pointer;
    display: flex;
    align-items: center;
}

.selected-category-button:hover {
    background: #ddd;
}

.remove-category {
    margin-left: 4px;
    font-weight: bold;
    color: #666;
}

.selected-categories-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.selected-tags {
    padding: 8px 12px;
    border-bottom: 1px solid rgb(36 42 101 / 45%);
}

.selected-tags h6 {
    margin: 0 0 6px 0;
    font-size: 13px;
    font-weight: 600;
    color: #666;
}

.selected-tags-list {
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    padding: 0;
    margin: 0;
}

.selected-tag-button {
    color: rgb(65, 65, 65);
    background-color: rgb(255, 255, 255);
    border: none;
    border-radius: 12px;
    padding: 4px 8px;
    font-size: 10px;
    cursor: pointer;
    display: flex;
    align-items: center;
}

.selected-tag-button:hover {
    background: #ddd;
}

.remove-tag {
    margin-left: 4px;
    font-weight: bold;
    color: #666;
}

.selected-tags-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.clear-all-button {
    background: none;
    border: none;
    color: #007aff;
    font-size: 12px;
    cursor: pointer;
    padding-bottom: 8px;
    padding-left: 15px;
}

.clear-all-button:hover {
    text-decoration: underline;
}


.selected-filters {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
    margin: 8px 10px;
}

.filters-list {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
}

.filter-chip {
    display: flex;
    align-items: center;
    background-color: rgba(36, 42, 101, 0.3);
    border: 1px solid rgba(36, 42, 101, 0.5);
    border-radius: 6px;
    padding: 4px 8px;
    color: #e8ebf7;
    font-size: 13px;
}

.filter-chip .chip-color {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-right: 6px;
}

.filter-chip .chip-remove {
    margin-left: 6px;
    background: none;
    border: none;
    color: #9aa3c3;
    cursor: pointer;
    font-size: 13px;
    transition: color 0.15s ease;
}

.filter-chip .chip-remove:hover {
    color: white;
}

.search-chip {
    background-color: rgba(80, 100, 200, 0.25);
    border: 1px solid rgba(80, 100, 200, 0.5);
}

.search-chip .chip-label strong {
    font-weight: 600;
    color: #aeb7ff;
}

.clear-all {
    margin-left: auto;
    background: none;
    border: none;
    color: #9aa3c3;
    font-size: 13px;
    cursor: pointer;
    padding: 4px 6px;
    transition: color 0.15s ease;
}

.clear-all:hover {
    color: white;
}
`, "",{"version":3,"sources":["webpack://./src/components/SelectedFilters.css"],"names":[],"mappings":";AACA;IACI,iBAAiB;IACjB,6CAA6C;AACjD;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,QAAQ;IACR,UAAU;IACV,SAAS;AACb;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,6CAA6C;AACjD;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,QAAQ;IACR,UAAU;IACV,SAAS;AACb;;AAEA;IACI,sBAAsB;IACtB,oCAAoC;IACpC,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;AAC9B;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,wCAAwC;IACxC,wCAAwC;IACxC,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,0CAA0C;IAC1C,yCAAyC;AAC7C;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,YAAY;AAChB","sourcesContent":["\n.selected-categories {\n    padding: 8px 12px;\n    border-bottom: 1px solid rgb(36 42 101 / 45%);\n}\n\n.selected-categories h6 {\n    margin: 0 0 6px 0;\n    font-size: 13px;\n    font-weight: 600;\n    color: #666;\n}\n\n.selected-categories-list {\n    list-style: none;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n    padding: 0;\n    margin: 0;\n}\n\n.selected-category-button {\n    color: rgb(65, 65, 65);\n    background-color: #d2d6e0;\n    border: none;\n    border-radius: 12px;\n    padding: 4px 8px;\n    font-size: 10px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n}\n\n.selected-category-button:hover {\n    background: #ddd;\n}\n\n.remove-category {\n    margin-left: 4px;\n    font-weight: bold;\n    color: #666;\n}\n\n.selected-categories-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.selected-tags {\n    padding: 8px 12px;\n    border-bottom: 1px solid rgb(36 42 101 / 45%);\n}\n\n.selected-tags h6 {\n    margin: 0 0 6px 0;\n    font-size: 13px;\n    font-weight: 600;\n    color: #666;\n}\n\n.selected-tags-list {\n    list-style: none;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n    padding: 0;\n    margin: 0;\n}\n\n.selected-tag-button {\n    color: rgb(65, 65, 65);\n    background-color: rgb(255, 255, 255);\n    border: none;\n    border-radius: 12px;\n    padding: 4px 8px;\n    font-size: 10px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n}\n\n.selected-tag-button:hover {\n    background: #ddd;\n}\n\n.remove-tag {\n    margin-left: 4px;\n    font-weight: bold;\n    color: #666;\n}\n\n.selected-tags-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.clear-all-button {\n    background: none;\n    border: none;\n    color: #007aff;\n    font-size: 12px;\n    cursor: pointer;\n    padding-bottom: 8px;\n    padding-left: 15px;\n}\n\n.clear-all-button:hover {\n    text-decoration: underline;\n}\n\n\n.selected-filters {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 6px;\n    margin: 8px 10px;\n}\n\n.filters-list {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n}\n\n.filter-chip {\n    display: flex;\n    align-items: center;\n    background-color: rgba(36, 42, 101, 0.3);\n    border: 1px solid rgba(36, 42, 101, 0.5);\n    border-radius: 6px;\n    padding: 4px 8px;\n    color: #e8ebf7;\n    font-size: 13px;\n}\n\n.filter-chip .chip-color {\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    margin-right: 6px;\n}\n\n.filter-chip .chip-remove {\n    margin-left: 6px;\n    background: none;\n    border: none;\n    color: #9aa3c3;\n    cursor: pointer;\n    font-size: 13px;\n    transition: color 0.15s ease;\n}\n\n.filter-chip .chip-remove:hover {\n    color: white;\n}\n\n.search-chip {\n    background-color: rgba(80, 100, 200, 0.25);\n    border: 1px solid rgba(80, 100, 200, 0.5);\n}\n\n.search-chip .chip-label strong {\n    font-weight: 600;\n    color: #aeb7ff;\n}\n\n.clear-all {\n    margin-left: auto;\n    background: none;\n    border: none;\n    color: #9aa3c3;\n    font-size: 13px;\n    cursor: pointer;\n    padding: 4px 6px;\n    transition: color 0.15s ease;\n}\n\n.clear-all:hover {\n    color: white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
